import QuickAccessRoutes from "@/router/development/quick_access.js";

export default [
  ...QuickAccessRoutes
];